
define('eteration/ui/char-utils',['jquery', 'knockout'],

function($,ko) {
	
	var keyboardKeys = { "BACKSPACE":8, "TAB":9,"ENTER":13,"SHIFT":16,"CTRL":17,"ALT":18, "PAUSEBREAK":19, "CAPSLOCK":20,"ESC":27, "SPACE":32, "PAGEUP":33, "PAGEDOWN":34, "OCTOTHORPE":35, "HOME":36, "LEFT":37, "AMPERSAND":38, "RIGHT":39, "RIGHT_ROUND_BRACKET":40, "LEFT_ROUND_BRACKET":41, "PRNTSCRN":44, "0":48, "1":49, "2":50, "3":51, "4":52, "5":53, "6":54, "7":55, "8":56, "9":57, "A":65, "B":66, "C":67, "D":68, "E":69, "F":70, "G":71, "H":72, "I":73, "J":74, "K":75, "L":76, "M":77, "N":78, "O":79, "P":80, "Q":81, "R":82, "S":83, "T":84, "U":85, "V":86, "W":87, "X":88, "Y":89, "Z":90, "WINKEY":91, "WINKEYR":92, "APPLICATION":93, "NUM0":96, "NUM1":97, "NUM2":98, "NUM3":99, "NUM4":100, "NUM5":101, "NUM6":102, "NUM7":103, "NUM8":104, "NUM9":105, "MULTIPLY":106, "ADD":107, "SUBTRACT":109, "DECIMALPOINT":110, "DIVIDE":111, "F1":112, "F2":113, "F3":114, "f4":115, "F5":116, "F6":117, "F7":118, "F8":119, "F9":120, "F10":121, "F11":122, "F12":123, "NUMLOCK":144, "SCROLLLOCK":145, "SEMICOLON":59, "COLON":58, "EQUAL":187, "COMMA":44, "DASH":45, "DELETE":46, "PERIOD":190, "SLASH":47, "GRAVE":192, "OPENBRAKET":219, "BACKSLASH":220, "CLOSEBRAKET":221, "SINGLEQUOTE":222, "QUOTE": 39, "MMNEXT":176, "MMPREVIOUS":177, "MMSTOP":178, "MMPLAY":179, "MMREWIND":227, "MMFORWARD":228, "MYCOMPUTER":182, "MYCALCULATOR":183, "HELP":225, "Invalid!":0};

	//http://unixpapa.com/js/key.html
	
	//KEY RANGES
	var rangeIsoLatinBasicAlphabetUpper = [64,91];
	var rangeIsoLatinBasicAlphabetLower = [96,123];
	var rangeNumbers = [47,58];
	var rangeKeypadNumbers = [95,106];

	//KEY ARRAYS					ğ  ,ü  ,ş  ,ı  ,ö  ,ç  ,â  ,î  ,û  ,Ğ  ,Ü  ,Ş  ,İ  ,Ö  ,Ç  ,Â  ,Î  ,Û
	var arrayNonStandardTurkish = [287,252,351,305,246,231,226,238,251,286,220,350,304,214,199,194,206,219];
	var arrayArrowKeys = [37,38,39,40];
	var arrayDefaultKeys = [keyboardKeys["BACKSPACE"],
	                        keyboardKeys["TAB"],
	                        keyboardKeys["CAPSLOCK"],
	                        keyboardKeys["LEFT"],
	                        keyboardKeys["RIGHT"],
	                        keyboardKeys["UP"],
	                        keyboardKeys["DOWN"],
	                        keyboardKeys["ESC"],
	                        keyboardKeys["ENTER"],
                            keyboardKeys["DELETE"]];


	var codeFromEvent = function(event){
		return event.which || event.keyCode || event.charCode || 0;
	}
	
	var shiftKeyFromEvent = function(event){
		return event.shiftKey === true;
	}
	
	var altKeyFromEvent = function(event){
		return event.altKey === true;
	}
	
	var isCodeInArray = function(code,array){
		return $.inArray(code, array) != -1;
	}
	
	var isCodeInRange = function(code,range){
		return code > range[0] && code < range[1];
	}
	
	var isCodeEquals = function(code,otherCode){
		return code == otherCode;
	}
	

	var validators = {
		"default-keys" 					: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeInArray(code, arrayDefaultKeys);},
		"latin-alphabet" 				: function (code,shiftKey,altKey) { return isCodeInRange(code, rangeIsoLatinBasicAlphabetUpper) || isCodeInRange(code, rangeIsoLatinBasicAlphabetLower);},
		"numbers" 						: function (code,shiftKey,altKey) { return isCodeInRange(code, rangeNumbers) || isCodeInRange(code, rangeKeypadNumbers);},
		"turkish-special-characters" 	: function (code,shiftKey,altKey) { return isCodeInArray(code, arrayNonStandardTurkish);},
		"space" 						: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["SPACE"]);},
		"dash" 							: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["DASH"]);}, //-
		"quote" 						: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["QUOTE"]);}, //'
		"dot" 							: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["PERIOD"]);}, //.
		"comma" 						: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["COMMA"]);}, //,
		"slash" 						: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["SLASH"]);}, // /
		"colon" 						: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["COLON"]);}, //:
		"ampersand"			 			: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["AMPERSAND"]);}, //&
		"octothorpe"			 		: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["OCTOTHORPE"]);}, //#
		"right-round-bracket" 			: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["RIGHT_ROUND_BRACKET"]);}, //(
		"left-round-bracket" 			: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["LEFT_ROUND_BRACKET"]);}, // )
		"semicolon" 					: function (code,shiftKey,altKey) { return !shiftKey && !altKey && isCodeEquals(code, keyboardKeys["SEMICOLON"]);}, //;
	}
	
	var isCodeValidForValidator = function(code, shiftKey, altKey, validator){
		return (typeof validator === "function" && validator(code, shiftKey, altKey));	
	}
	
	var isCodeValid = function(code, shiftKey, altKey, validators, validatorNames){
		if ($.isArray(validatorNames)) {
			
        	for (var validatorNameIndex = 0; validatorNameIndex < validatorNames.length; validatorNameIndex++) {

        		var validatorName = validatorNames[validatorNameIndex];
				
				var validator = validators[validatorName];
				
	        	var codeValidForValidator = isCodeValidForValidator(code, shiftKey, altKey, validator);
	        	
	        	if (codeValidForValidator) {
					return true;
				}
	        	
        	}
			
		}
		
		return false;	
	}	


	return{
		codeFromEvent:codeFromEvent,
		shiftKeyFromEvent:shiftKeyFromEvent,
		altKeyFromEvent:altKeyFromEvent,
		isCodeValid:isCodeValid,
		validators:validators
	}			
	
});





